"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineWhichHandleShouldBeDraggedForTouchAndTwoHandles = exports.determineWhichHandleShouldBeDraggedForTouchAndOneHandle = exports.determineWhichHandleShouldBeDraggedForMouseAndTwoHandles = exports.determineWhichHandleShouldBeDraggedForMouseAndOneHandle = void 0;
var Geometry_1 = require("../../utils/Geometry");
// eslint-disable-next-line import/no-cycle
var SliderBaseWidget_1 = require("./SliderBaseWidget");
/**
 * This contains logic related to determining which handle to drag given the client coordinates from a mouse or touch
 * event.  The SliderHandleContainer needs this and is the only user.
 *
 * The logic for this at a high level is (even though this is broken into multiple methods):
 * ```
 * if mouse then
 *   if there is only one handle then
 *     return the left handle (clicking anywhere on the track grabs the handle)
 *   otherwise (if there are two handles) then
 *     if the click is between the *ICONS* return saying that both handles should be dragged
 *     otherwise return the handle that is closer to the click
 * otherwise (if touch) then
 *   if there is only one handle then
 *     if the touch is directly on the *INTERACTIVE AREA* for the left handle, return that
 *   otherwise (if there are two handles) then
 *     if the touch is on both the *INTERACTIVE AREA*s for both handles, return the one that is closer to the touch
 *     otherwise if it is on only one of the *INTERACTIVE AREA*s return that
 * and if none of those situations above are true, return nothing
 * ```
 */
function determineWhichHandleShouldBeDraggedForMouseAndOneHandle(clientCoordinates, leftHandleIconBoundingClientRect) {
    var point = { left: clientCoordinates.x, top: clientCoordinates.y };
    var directlyOnIcon = Geometry_1.doesRectangleContainPoint(leftHandleIconBoundingClientRect, point);
    return { handleType: SliderBaseWidget_1.HandleType.Left, directlyOnIcon: directlyOnIcon };
}
exports.determineWhichHandleShouldBeDraggedForMouseAndOneHandle = determineWhichHandleShouldBeDraggedForMouseAndOneHandle;
function determineWhichHandleShouldBeDraggedForMouseAndTwoHandles(clientCoordinates, leftHandleIconBoundingClientRect, rightHandleIconBoundingClientRect) {
    var point = { left: clientCoordinates.x, top: clientCoordinates.y };
    if (Geometry_1.doesRectangleContainPoint(leftHandleIconBoundingClientRect, point)) {
        return { handleType: SliderBaseWidget_1.HandleType.Left, directlyOnIcon: true };
    }
    else if (Geometry_1.doesRectangleContainPoint(rightHandleIconBoundingClientRect, point)) {
        return { handleType: SliderBaseWidget_1.HandleType.Right, directlyOnIcon: true };
    }
    if (clientCoordinates.x >= leftHandleIconBoundingClientRect.right &&
        clientCoordinates.x <= rightHandleIconBoundingClientRect.left) {
        return { handleType: SliderBaseWidget_1.HandleType.Both, directlyOnIcon: false };
    }
    else if (clientCoordinates.x <= leftHandleIconBoundingClientRect.right) {
        return { handleType: SliderBaseWidget_1.HandleType.Left, directlyOnIcon: false };
    }
    return { handleType: SliderBaseWidget_1.HandleType.Right, directlyOnIcon: false };
}
exports.determineWhichHandleShouldBeDraggedForMouseAndTwoHandles = determineWhichHandleShouldBeDraggedForMouseAndTwoHandles;
function determineWhichHandleShouldBeDraggedForTouchAndOneHandle(clientCoordinates, leftHandleInteractiveAreaBoundingClientRect) {
    var point = { left: clientCoordinates.x, top: clientCoordinates.y };
    // For touch we are "more loose" with our interpretation of what counts as being directly on the icon than mouse.
    var directlyOnIcon = Geometry_1.doesRectangleContainPoint(leftHandleInteractiveAreaBoundingClientRect, point);
    if (directlyOnIcon) {
        return { handleType: SliderBaseWidget_1.HandleType.Left, directlyOnIcon: true };
    }
    // we don't allow the user to touch and drag anywhere on the track, like they can w/ a mouse, since that is
    // actually quite annoying on touch when the user is trying to scroll the page (instead of manipulate the slider).
    return undefined;
}
exports.determineWhichHandleShouldBeDraggedForTouchAndOneHandle = determineWhichHandleShouldBeDraggedForTouchAndOneHandle;
function determineWhichHandleShouldBeDraggedForTouchAndTwoHandles(clientCoordinates, leftHandleInteractiveAreaBoundingClientRect, rightHandleInteractiveAreaBoundingClientRect, rangeHandleInteractiveAreaBoundingClientRect) {
    var point = { left: clientCoordinates.x, top: clientCoordinates.y };
    // For touch we are "more loose" with our interpretation of what counts as being directly on the icon than mouse.
    var directlyOnLeftIcon = Geometry_1.doesRectangleContainPoint(leftHandleInteractiveAreaBoundingClientRect, point);
    var directlyOnRightIcon = Geometry_1.doesRectangleContainPoint(rightHandleInteractiveAreaBoundingClientRect, point);
    var directlyOnRangeHandle = Geometry_1.doesRectangleContainPoint(rangeHandleInteractiveAreaBoundingClientRect, point);
    if (directlyOnLeftIcon && directlyOnRightIcon) {
        var distanceToLeftHandle = Math.abs(point.left - leftHandleInteractiveAreaBoundingClientRect.left);
        var distanceToRightHandle = Math.abs(point.left - rightHandleInteractiveAreaBoundingClientRect.right);
        var isCloserToLeftHandle = distanceToLeftHandle < distanceToRightHandle;
        return { handleType: isCloserToLeftHandle ? SliderBaseWidget_1.HandleType.Left : SliderBaseWidget_1.HandleType.Right, directlyOnIcon: true };
    }
    else if (directlyOnLeftIcon) {
        return { handleType: SliderBaseWidget_1.HandleType.Left, directlyOnIcon: true };
    }
    else if (directlyOnRightIcon) {
        return { handleType: SliderBaseWidget_1.HandleType.Right, directlyOnIcon: true };
    }
    else if (directlyOnRangeHandle) {
        return { handleType: SliderBaseWidget_1.HandleType.Both, directlyOnIcon: true };
    }
    // we don't allow the user to touch and drag anywhere on the track, like they can w/ a mouse, since that is
    // actually quite annoying on touch when the user is trying to scroll the page (instead of manipulate the slider).
    return undefined;
}
exports.determineWhichHandleShouldBeDraggedForTouchAndTwoHandles = determineWhichHandleShouldBeDraggedForTouchAndTwoHandles;
//# sourceMappingURL=SliderHandleContainerDragHandleLogic.js.map